
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/notifikasi",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/notifikasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/notifikasi"])
      });
    }
  